
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe16 as ObiHydraulicPipe16Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-16.js';
 
 
 

 
 export const ObiHydraulicPipe16 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-16',
   elementClass: ObiHydraulicPipe16Element,
   events: {
     
   }
  });
 
 